import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import BannerHeader from "../images/register/BANDEAU_INSCRIPTION.png";
import IconCompleted from '../images/register/INSCRIPTION_TERMINEE.png';
import { Col, Container, Row } from "react-bootstrap";
import MetaTags from "react-meta-tags";
import { useAuth } from '../ReactApp';


function RegisterSuccessPage() {
  const { user } = useAuth();

  if (!user) {
    return <p>Vous devez vous connecter pour voir cette page.</p>;
  }

  return (
    <div className="register-form">
      <MetaTags>
        <title>Louez et Gérer vos Véhicules pour le Béton |</title>
        <meta
          name="description"
          content="Inscrivez-vous sur SoluSpots pour accéder à un large choix de véhicules pour le béton. Rejoignez notre plateforme pour louer, gérer et optimiser vos opérations de chantier dès aujourd'hui."
        />
      </MetaTags>

      <Link to="/">
        <img src={BannerHeader} alt="SoluSpots - La solution en béton" />
      </Link>

      <div className="register-form-content">
        <div className='register-form-content-items'>
          <Row>
            <Col md={1} lg={2}></Col>
            <Col md={10} lg={8}>
              <div className='register-final'>
                <h2>Félicitations !</h2>
                <img className='type-block-image' src={IconCompleted} />
                <p>Votre inscription est terminée, l’activation de votre compte est en cours de vérification&nbsp;!<br />
                  <span>Découvrez sans plus tarder nos offres et commencez votre aventure avec SoluSpots&nbsp;!</span>
                </p>
                <a 
                  className="solu-btn solu-btn-primary"
                  href={`/selection-offre`}
                >
                  Je découvre les offres SoluSpots
                </a>
              </div>
            </Col>
            <Col md={1} lg={2}></Col>
          </Row>
        </div>
      </div>
    </div>
  );
}

export default RegisterSuccessPage;
